<template>
  <div class="mx-auto w-full px-4 pt-12 pb-40">
    <div :class="card ? 'variant-card' : 'variant-plain'">
      <div
        v-if="pill || title"
        class="mb-6 flex flex-col items-center gap-6 sm:mb-8 sm:gap-4"
      >
        <span v-if="pill" class="variant-pill">{{ pill }}</span>
        <h1 v-if="title" class="variant-card__title">{{ title }}</h1>
      </div>

      <slot name="body" />
    </div>

    <div class="variant-bottom-bar">
      <slot name="footer">
        <div class="variant-bottom-bar__row">
          <button
            v-if="showBackBtn"
            id="footerBackButton"
            type="button"
            class="variant-bottom-bar__back"
            @click="$router.back()"
          >
            {{ $t('global.back') }}
          </button>

          <!-- Button and subtext share a column so the subtext centres on the
               button rather than on the bar, which the back button offsets. -->
          <div class="variant-bottom-bar__action">
            <button
              id="footerNextButton"
              v-track-click
              type="button"
              class="variant-bottom-bar__next"
              @click="$nuxt.$emit('submit')"
            >
              {{ nextBtnText || $t('global.continue') }}
            </button>

            <p v-if="subtext" class="variant-bottom-bar__subtext">
              {{ subtext }}
            </p>
          </div>
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormShellPD10913',

  props: {
    pill: {
      type: String,
      default: '',
    },

    title: {
      type: String,
      default: '',
    },

    showBackBtn: {
      type: Boolean,
      default: false,
    },

    nextBtnText: {
      type: String,
      default: '',
    },

    subtext: {
      type: String,
      default: '',
    },

    card: {
      type: Boolean,
      default: true,
    },
  },
}
</script>
